import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { SvgIconProps } from '@mui/material';

export const ShellAndTubeIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      {/* Shell body - longer and sleeker */}
      <rect x="2" y="8" width="20" height="8" rx="0.5" stroke="currentColor" strokeWidth="1" fill="none" />
      
      {/* Tubes - fewer tubes */}
      <line x1="3" y1="9.5" x2="21" y2="9.5" stroke="currentColor" strokeWidth="0.75" />
      <line x1="3" y1="12" x2="21" y2="12" stroke="currentColor" strokeWidth="0.75" />
      <line x1="3" y1="14.5" x2="21" y2="14.5" stroke="currentColor" strokeWidth="0.75" />

      {/* Tube sheets at ends - extended above and below */}
      <rect x="1" y="6" width="1" height="12" fill="currentColor" />
      <rect x="22" y="6" width="1" height="12" fill="currentColor" />

      {/* End caps - sleeker design */}
      <path d="M2 8 L22 8 L22 7 L2 7 Z" fill="currentColor" />
      <path d="M2 16 L22 16 L22 17 L2 17 Z" fill="currentColor" />

      {/* Refrigerant inlet/outlet connections - rectangular */}
      <rect x="10.5" y="4" width="3" height="2" fill="currentColor" />
      <rect x="10.5" y="18" width="3" height="2" fill="currentColor" />
      <circle cx="0" cy="10" r="1" fill="currentColor" />
      <circle cx="0" cy="14" r="1" fill="currentColor" />
    </SvgIcon>
  );
}; 